module.exports = __webpack_public_path__ + "static/media/icon_othercode.bf792f1a.svg";